function getAuthorization() {
  const token = localStorage.getItem("authToken");
  return token ;
}
function getCompanyId() {
  const companyId = localStorage.getItem("companyId");
  return companyId;
}
function setAuthorization(token, companyId) {
  localStorage.setItem("authToken", token);
  localStorage.setItem("companyId", companyId);
  return true;
}

function removeAuthorization() {
  localStorage.removeItem("authToken");
  localStorage.removeItem("companyId");
  return true;
}

export {
  getAuthorization,
  setAuthorization,
  removeAuthorization,
  getCompanyId,
};
